export default __webpack_public_path__ + "static/media/main_logo.35db7ae2.svg";